import { v4 as uuidv4 } from 'uuid'
import { getStorageItem } from './getStorageItem'

export function getTransactionId() {
  const transactionId = getStorageItem('transactionId') || uuidv4()
  window.sessionStorage.setItem('transactionId', transactionId)

  return transactionId
}